document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  const thumb = event.target.closest('.product-media__thumb');

  if (thumb) {
    event.preventDefault();
    const featured = thumb.closest('.product-main__media')?.querySelector('.product-media__featured img');
    const thumbImage = thumb.querySelector('img');
    if (featured && thumbImage) {
      featured.src = thumb.href;
      featured.srcset = '';
      featured.alt = thumbImage.alt || featured.alt;
    }
    return;
  }

  if (!toggle) return;

  const menu = document.querySelector('[data-menu]');
  const expanded = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!expanded));
  menu?.classList.toggle('is-open', !expanded);
});

class VariantSelects extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange() {
    const variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    const selectedOptions = Array.from(this.querySelectorAll('select')).map((select) => select.value);
    const currentVariant = variants.find((variant) => {
      return variant.options.every((option, index) => option === selectedOptions[index]);
    });

    if (!currentVariant) return;

    const form = this.closest('form');
    const productSection = this.closest('.product-main');
    const idInput = form?.querySelector('input[name="id"]');
    const submit = form?.querySelector('button[type="submit"]');
    if (idInput) idInput.value = currentVariant.id;
    if (submit) {
      submit.disabled = !currentVariant.available;
      submit.textContent = currentVariant.available ? window.MissladyxTheme.addToCart : window.MissladyxTheme.soldOut;
    }

    const price = productSection?.querySelector('[data-regular-price]');
    if (price) price.textContent = formatMoney(currentVariant.price, window.MissladyxTheme.moneyFormat);

    const stock = productSection?.querySelector('[data-stock]');
    if (stock) {
      stock.textContent = currentVariant.available ? window.MissladyxTheme.inStock : window.MissladyxTheme.soldOut;
      stock.classList.toggle('stock--in', currentVariant.available);
      stock.classList.toggle('stock--out', !currentVariant.available);
    }

    const sku = productSection?.querySelector('[data-sku]');
    if (sku) sku.textContent = currentVariant.sku || '';
  }
}

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', VariantSelects);
}

document.addEventListener('change', (event) => {
  if (event.target.closest('.language-switcher')) {
    event.target.form?.submit();
    return;
  }

  if (!event.target.closest('#FacetFiltersForm')) return;
  event.target.form?.submit();
});

function formatMoney(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  const value = (cents / 100).toFixed(2);
  return format
    .replace(/\{\{\s*amount\s*\}\}/, value)
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString());
}
